import { useRef, useState } from "react";

function useAccordion(props) {
  const { defaultCollapsed } = props;
  const BLOCK = useRef("accordion");
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const handleToggle = () => {
    setCollapsed((open) => !open);
  };

  return {
    BLOCK,
    collapsed,
    handleToggle,
  };
}

const Hook = {
  useAccordion,
};

export default Hook;
